import { observer } from 'mobx-react-lite';
import { useRef, useState } from 'react';
import { useStore } from '../../../stores/store';
import {
  HeaderOptionsButton,
  ValueHolder,
} from './header-settings-popup.styles';
import { ReactComponent as GlobeIcon } from '../../../assets/GlobePointer.svg';
import { useIsMobile } from '../../../hooks/use-is-mobile.hook';
import HeaderSettingsPopup from './header-settings-popup';
import HeaderSettingsPopupMobile from './header-settings-popup-mobile';
import { testIds } from '../../../../test-ids';

const HeaderRegionSettings = () => {
  const {
    navStore: { toggleSidebarByName },
    localizationsStore: { selectedLocalization, selectedCountry },
  } = useStore();

  const [isDesktopOpen, setIsDesktopOpen] = useState(false);
  const optionsButtonRef = useRef<HTMLDivElement>(null);

  const isMobile = useIsMobile();

  const handleClick = () => {
    if (isMobile) {
      toggleSidebarByName('header_settings_popup_mobile');
    } else {
      setIsDesktopOpen((prev) => !prev);
    }
  };

  return (
    <>
      <HeaderOptionsButton
        data-testid={testIds.header.languageSelector}
        ref={optionsButtonRef}
        onClick={(e) => {
          e.stopPropagation();
          handleClick();
        }}>
        <ValueHolder>
          <GlobeIcon />
          {selectedCountry?.alias?.toUpperCase()}
        </ValueHolder>

        <div className='divider' />

        <ValueHolder>{selectedLocalization?.code?.toUpperCase()}</ValueHolder>

        {!isMobile && isDesktopOpen && (
          <HeaderSettingsPopup
            setIsOpened={setIsDesktopOpen}
            triggerRef={optionsButtonRef}
          />
        )}
      </HeaderOptionsButton>

      {isMobile && <HeaderSettingsPopupMobile />}
    </>
  );
};

export default observer(HeaderRegionSettings);
